<script setup lang="ts">
import { toggleActions } from "@/action/toggleActions";
import SidePanel from "@/components/SidePanel/SidePanel.vue";
import { sendStickyNoteAction } from "@/composables/useEventBus";
import { useActivityStore } from "@/store/activity";
import { useBoardStore } from "@/store/board";

import BoardDiffPanel from "./BoardDiffPanel.vue";
import BoardLogPanel from "./BoardLogPanel.vue";
import BoardStatePanel from "./BoardStatePanel.vue";

const store = useActivityStore();

const close = () => {
  const enlargedSticky = useBoardStore().enlargedStickyNoteId;
  if (enlargedSticky) sendStickyNoteAction(enlargedSticky, { action: "shrink" });
  toggleActions.toggleBoardHistory("close-button");
};
</script>

<template>
  <div class="board-history-panel" data-ignore-click @scroll.stop>
    <SidePanel side="left" :active="store.board" name="boardDiff" resizable @close="close">
      <template v-if="store.isBoardActivityOpen">
        <BoardLogPanel v-if="store.tab === 'log'" />
        <BoardDiffPanel v-if="store.tab === 'compare'" />
        <BoardStatePanel v-if="store.tab === 'visualize'" />
      </template>
    </SidePanel>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/z-index";
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";

.board-history-panel {
  position: relative;
  z-index: z-index.$menu;

  :deep(.panel-header) {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .subtitle {
      @include typography.medium("bold");

      color: colors.$text;
    }

    .description {
      @include typography.small("semi-bold");
    }
  }
}
</style>
